module.exports = __webpack_public_path__ + "img/admin.46605c17.jpeg";